import React from "react";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import "./alumni.css";

const alumniData = [
    {
        id: 1,
        image: "/assets/images/alumni/Mahesh Korde.webp",
        name: "Mahesh Korade ",
        course: "B.Tech Computer Science",
        year: "Passout Batch: 2005",
        des1: "Extra First Class, PGDSM&L, Ex IRS",
        des2: "Engineer and Ship Surveyor cum Deputy Director General of Shipping, MMD, MUMBAI",
        message:
            "Mahesh Korade is a distinguished alumnus of B. Tech Marine Engineering from MANET, MIT ADT University, Pune (2005 batch). He has achieved the prestigious Extra First-Class certification and holds a PG Diploma in Shipping Management & Logistics (PGDSM&L). With prior experience in the Indian Register of Shipping (IRS), he currently serves as an Engineer and Ship Surveyor cum Deputy Director General of Shipping at MMD, Mumbai. His career reflects technical excellence and significant contributions to maritime administration and safety.",
    },
    {
        id: 2,
        image: "/assets/images/alumni/Neha Mehta.jfif",
        name: "Neha Mehta",
        course: "B-Tech Marine Engineering, ",
        year: "Passout Batch: 2006",
        des1: "MANET, MIT ADT University, Pune. ",
        des2: "CEO of NextMariner",
        message:
            "Neha Mehta, a 2006 graduate in B. Tech Marine Engineering from MANET, MIT ADT University, Pune, is an accomplished industry leader and entrepreneur. She is the CEO of NextMariner, where she plays a key role in driving innovation and leadership within the maritime sector. Her journey showcases the growing presence and impact of women in marine engineering and maritime leadership roles.",
    },
    {
        id: 3,
        image: "/assets/images/alumni/Avinash Jadhav.webp",
        name: "Avinash Jadhav",
        course: "B-Tech Marine Engineering ",
        year: "Passout Batch: 2007",
        des1: "(IAAS 2014 batch)",
        des2: "Director, O/o CAG of India, New Delhi",
        message:
            "Avinash Jadhav completed his B. Tech in Marine Engineering from MANET, MIT ADT University, Pune in 2007. A member of the IAAS 2014 batch, he currently serves as Director in the Office of the Comptroller and Auditor General (CAG) of India, New Delhi. His career demonstrates a successful transition from technical maritime education to a prestigious role in government administration and public service.",
    },
    {
        id: 4,
        image: "/assets/images/alumni/Sanket Joshi.jfif",
        name: "Sanket Joshi",
        course: "B. Tech Marine Engineering",
        year: "Passout Batch: 2010",
        des1: "MANET, MIT ADT University, Pune. ",
        des2: "Currently Working as General Manager at DP World. ",
        message:
            "Sanket Joshi, a 2010 B. Tech Marine Engineering graduate from MANET, MIT ADT University, Pune, has built a strong professional career in the global logistics and port operations industry. He is currently working as a General Manager at DP World, contributing to efficient port management and international trade operations.",
    },
    {
        id: 5,
        image: "/assets/images/alumni/Shankar Mohan.webp",
        name: "Shankar Mohan",
        course: "B-Tech Marine Engineering ",
        year: "Passout Batch: 2010",
        des1: "PGPX 2020-21",
        des2: "Indian Institute of Management, Ahmedabad",
        message:
            "Shankar Mohan graduated in B. Tech Marine Engineering from MANET, MIT ADT University, Pune in 2010. He further enhanced his managerial expertise by completing the PGPX program (2020–21) from the Indian Institute of Management Ahmedabad. His academic and professional journey reflects a blend of technical knowledge and advanced leadership skills, positioning him for senior roles in industry and management.",
    },
      {
        id: 6,
        image: "/assets/images/alumni/Anish Wankhede.webp",
        name: "Anish Wankhede",
        course: "B-Tech Marine Engineering ",
        year: "Passout Batch: 2006",
        des1: "MANET, MIT ADT University, Pune.",
        des2: "Co-Founder & Chief Operating Officer, Marine Insight",
        message:
            "Anish Wankhede, a B. Tech Marine Engineering graduate from the 2006 batch, is the Co-Founder and Chief Operating Officer of Marine Insight—one of the most widely recognized platforms for maritime knowledge today.",
    },
];

const ProudAlumni = () => {
    return (
        <div>
            <h1 className="title">Proud Alumni</h1>
            <hr />
            <div className="proud-alumni-grid">
                {alumniData.map((alumni) => (
                    <div className="alumni-card" key={alumni.id}>

                        {/* Top Section */}
                        <div className="alumni-top">
                            <img
                                src={alumni.image}
                                alt={alumni.name}
                                className="proud-alumni-img"
                            />

                            <div className="alumni-info">
                                <h3 className="ach-name">{alumni.name}</h3>
                                <ul className="page-content-lists ">
                                    <li>{alumni.course}</li>
                                    <li>{alumni.year}</li>
                                    <li>{alumni.des1}</li>
                                    <li>{alumni.des2}</li>
                                </ul>

                            </div>
                        </div>

                        {/* Message */}
                        <div className="message">
                            <FaQuoteLeft className="quote-icon left" />
                            <p>{alumni.message}</p>
                            <FaQuoteRight className="quote-icon right" />
                        </div>

                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProudAlumni;